import React, {
  useEffect,
  useRef,
  useState
} from "react";

import axios from "axios";

import {
  API_URL
} from "../config/api";


function VerifyEmail() {

  const [status, setStatus] =
    useState("verifying");

  const [message, setMessage] =
    useState(
      "Verifying your email..."
    );

  const [verifiedEmail, setVerifiedEmail] =
    useState("");

  const [
    completionToken,
    setCompletionToken
  ] =
    useState("");

    const [name, setName] =
  useState("");

const [phone, setPhone] =
  useState("");

const [school, setSchool] =
  useState("");

const [
  collegeUniversity,
  setCollegeUniversity
] =
  useState("");

const [opinion, setOpinion] =
  useState("");

const [consent, setConsent] =
  useState(false);

const [
  submitting,
  setSubmitting
] =
  useState(false);

  const verificationStartedRef =
    useRef(false);


  useEffect(() => {

    /*
     * Prevent accidental duplicate verification
     * requests during React development mode.
     */
    if (
      verificationStartedRef.current
    ) {
      return;
    }

    verificationStartedRef.current =
      true;


    const verifyEmail = async () => {

      const hash =
        window.location.hash || "";

      const hashParams =
        new URLSearchParams(
          hash.startsWith("#")
            ? hash.slice(1)
            : hash
        );

      const token =
        hashParams.get("token") || "";


      /*
       * SECURITY:
       * Remove the raw verification token
       * from the browser address bar as
       * soon as we have read it.
       */
      window.history.replaceState(
        null,
        "",
        window.location.pathname
      );


      if (
        !/^[a-f0-9]{64}$/i.test(
          token
        )
      ) {

        setStatus("error");

        setMessage(
          "This verification link is invalid or has expired."
        );

        return;

      }


      try {

        const response =
          await axios.post(
            `${API_URL}/api/community/verification/confirm`,
            {
              token
            }
          );


        if (
          !response.data?.completionToken ||
          !response.data?.email
        ) {

          throw new Error(
            "Incomplete verification response."
          );

        }


        setVerifiedEmail(
          response.data.email
        );

        setCompletionToken(
          response.data.completionToken
        );

        setStatus("verified");

        setMessage(
          "Your email has been verified successfully."
        );

      } catch (error) {

        setStatus("error");

        setMessage(
          error.response?.data?.message ||
          "Unable to verify this email right now."
        );

      }

    };


    verifyEmail();

  }, []);

  const handleComplete =
  async (event) => {

    event.preventDefault();

    if (
      submitting ||
      !completionToken
    ) {
      return;
    }


    setSubmitting(true);


    try {

      const response =
        await axios.post(
          `${API_URL}/api/community/complete`,
          {
            completionToken,
            name,
            phone,
            school,
            collegeUniversity,
            opinion,
            consent
          }
        );


      setCompletionToken("");

      setStatus("completed");

      setMessage(
        response.data?.message ||
        "You have successfully joined the Chatra Sangbad Circle."
      );

    } catch (error) {

      setMessage(
        error.response?.data?.message ||
        "Unable to complete your registration right now."
      );

    } finally {

      setSubmitting(false);

    }

  };

  const handleCancel =
  async () => {

    if (!completionToken) {
      return;
    }


    const token =
      completionToken;


    /*
     * Remove it from React state immediately.
     * Even if the network request fails,
     * this browser no longer retains it.
     */
    setCompletionToken("");

    try {

      await axios.post(
        `${API_URL}/api/community/verification/cancel`,
        {
          completionToken:
            token
        }
      );

    } catch (error) {

      console.error(
        "Unable to cancel verification session."
      );

    }


    setStatus("cancelled");

    setMessage(
      "Registration cancelled."
    );

  };


  return (

    <main className="join-circle-page">

      <section className="join-circle-panel">

        <p className="join-circle-eyebrow">
          Beyond the Feed
        </p>

        <h1>
          Email Verification
        </h1>


        {status === "verifying" && (

  <div
    className="join-circle-message"
    role="status"
    style={{
      background: "#f5f5f5",
      color: "#555555",
      border: "1px solid #dddddd"
    }}
  >
    {message}
  </div>

)}


        {status === "error" && (

          <div
            className="
              join-circle-message
              join-circle-message--error
            "
            role="alert"
          >
            {message}
          </div>

        )}


        {status === "verified" &&
  completionToken && (

  <>

    <div
      className="
        join-circle-message
        join-circle-message--success
      "
      role="status"
    >
      {message}
    </div>


    <form
      className="join-circle-form"
      onSubmit={handleComplete}
      style={{
        marginTop: "26px"
      }}
    >

      <div className="join-circle-field">

        <label>
          Email verified
        </label>

        <input
          type="email"
          value={verifiedEmail}
          readOnly
          aria-readonly="true"
        />

      </div>


      <div className="join-circle-field">

        <label htmlFor="circle-name">
          Name *
        </label>

        <input
          id="circle-name"
          type="text"
          value={name}
          onChange={(event) =>
            setName(
              event.target.value
            )
          }
          maxLength={80}
          autoComplete="name"
          required
        />

      </div>


      <div className="join-circle-field">

        <label htmlFor="circle-phone">
          Phone
          <span>
            {" "}(optional)
          </span>
        </label>

        <input
          id="circle-phone"
          type="tel"
          value={phone}
          onChange={(event) =>
            setPhone(
              event.target.value
            )
          }
          maxLength={30}
          autoComplete="tel"
        />

      </div>


      <div className="join-circle-field">

        <label htmlFor="circle-school">
          School
          <span>
            {" "}(optional)
          </span>
        </label>

        <input
          id="circle-school"
          type="text"
          value={school}
          onChange={(event) =>
            setSchool(
              event.target.value
            )
          }
          maxLength={150}
        />

      </div>


      <div className="join-circle-field">

        <label htmlFor="circle-college">
          College / University
          <span>
            {" "}(optional)
          </span>
        </label>

        <input
          id="circle-college"
          type="text"
          value={collegeUniversity}
          onChange={(event) =>
            setCollegeUniversity(
              event.target.value
            )
          }
          maxLength={150}
        />

      </div>


      <div className="join-circle-field">

        <label htmlFor="circle-opinion">
          Your opinion / feedback
          <span>
            {" "}(optional)
          </span>
        </label>

        <textarea
          id="circle-opinion"
          value={opinion}
          onChange={(event) =>
            setOpinion(
              event.target.value
            )
          }
          maxLength={2000}
          rows={6}
          placeholder="Share your thoughts with us"
        />

        <small
          style={{
            textAlign: "right",
            color: "#777777"
          }}
        >
          {opinion.length}/2000
        </small>

      </div>


      <label className="join-circle-consent">

        <input
          type="checkbox"
          checked={consent}
          onChange={(event) =>
            setConsent(
              event.target.checked
            )
          }
          required
        />

        <span>
          I consent to Chatra Sangbad
          storing the information I
          submit for the purpose of
          managing the Circle.
        </span>

      </label>


      <div
        style={{
          display: "flex",
          gap: "12px",
          flexWrap: "wrap"
        }}
      >

        <button
          type="submit"
          className="join-circle-submit"
          disabled={submitting}
        >
          {submitting
            ? "Submitting..."
            : "Submit"}
        </button>


        <button
          type="button"
          onClick={handleCancel}
          disabled={submitting}
          style={{
            padding: "11px 20px",
            border:
              "1px solid #bbbbbb",
            borderRadius: "7px",
            background: "#ffffff",
            color: "#333333",
            fontFamily: "inherit",
            fontSize: "15px",
            fontWeight: "700",
            cursor: "pointer"
          }}
        >
          Cancel
        </button>

      </div>

    </form>

  </>

)}

{status === "completed" && (

  <div
    className="
      join-circle-message
      join-circle-message--success
    "
    role="status"
  >
    {message}
  </div>

)}


{status === "cancelled" && (

  <div
    className="
      join-circle-message
      join-circle-message--error
    "
    role="status"
  >
    {message}
  </div>

)}

      </section>

    </main>

  );

}


export default VerifyEmail;